import { useEffect, useState } from "react";
import apiClient from "@/services/apiClient";

export function useCampusLocations() {
  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const fetchLocations = async () => {
      try {
        const apiBaseUrl = process.env.REACT_APP_API_URL;
        const response = await apiClient.get(`${apiBaseUrl}/campuses/GetAllLocations`);

        if (!isMounted) return;

        const data = Array.isArray(response.data) ? response.data : [];
        setLocations(data.filter((item) => !item.isDeleted && !item.isDisable));
      } catch (error) {
        console.error("Failed to fetch campus locations", error);
        if (isMounted) {
          setLocations([]);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    fetchLocations();

    return () => {
      isMounted = false;
    };
  }, []);

  return { locations, loading };
}
